import Restapi from "../api/Restapi";
import {REPORTING_URL, constats} from "../constant"


export const GetAllChemistByCity = async (cityid) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('get',REPORTING_URL+'/apiv1/chemist/city/'+cityid,null);
}


export const GetAllChemistByCities = async (cityid) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('post',REPORTING_URL+'/apiv1/chemist/cities',cityid);
}

export const UpdateUserChemistStatus = async (id,status) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    
    return await Restapi('put',REPORTING_URL+`/apiv1/userchemist/update/${id}/${status}`,null);
}

export const DeleteUserChemistStatus = async (id) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('delete',REPORTING_URL+'/apiv1/userchemist/'+id,null);
}

export const AddUserChemistData = async (userid,chemistid) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    let data = JSON.stringify({
        "userid":userid,
        "chemistid":chemistid,
        "status":"ACTIVE"
    });
    return await Restapi('post',REPORTING_URL+'/apiv1/userchemist',data);
}


export const CreateUserChemistData = async (userid,areas,chemistname,address,countryid,stateid,cityid,pincode,phone,email) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    var arr = [areas];
    let data = JSON.stringify({
        "userid":userid,
        "status":"PENDING_FOR_ADDITION",
        "areas":arr,
        "chemistname":chemistname,
        "address":address,
        "countryid":countryid,
        "stateid":stateid,
        "cityid":cityid,
        "pincode":pincode,
        "phone":phone,
        "email":email,
        "createdby":userid
    });
    return await Restapi('post',REPORTING_URL+'/apiv1/userchemist/create',data);
}

export const GetAllChemistbyUserStatus = async (user,status) => {
    const [AUTH_URL, REPORTING_URL] = await constats();
    return await Restapi('get',REPORTING_URL+'/apiv1/userchemist/status/'+user+'/'+status,null);
}